<ng-container *transloco="let t;">
  <ng-container *ngIf="employee">
    <div class="flex flexDirRow alignCenter" style="margin-bottom: 50px">
      <h1 class="mrs"> {{ t('home.greeting') }} {{employee.firstName}} {{employee.lastName}}</h1>
      <button
        kendoButton
        fillMode="flat"
        [svgIcon]="gearIcon"
        [title]="t('home.widgetSettings')"
        (click)="openWidgetDialog()"
      ></button>
    </div>

    <div class="grid col4">
    <!-- Widgets render in the user's saved order; the calendar always spans the full row. -->
    @for (widget of orderedWidgets; track widget.key) {
    @if (widget.visible) {
    @switch (widget.key) {
    @case ('calendar') {
    <div class="break">
      <kendo-scheduler
        [events]="schedulerEvents$ | async"
        [selectedDate]="selectedDate"
        (dateChange)="onDateChange($event)"
        [workDayStart]="(tenantSettings$ | async)?.startMorningWorkTime"
        [workDayEnd]="(tenantSettings$ | async)?.endAfternoonWorkTime"
        [showWorkHours]="true"
        eventHeight=120
        [columnWidth]="50"
        [slotClass]="setSlotBackgroundColor"
        [eventStyles]="setBorderColor"
        (schedulerResize)="onSchedulerResize($event)"
        [loading]="isLoading"
      >

      <ng-template
          kendoSchedulerToolbarTemplate
          let-selectedDate="selectedDate"
          class="k-scheduler-toolbar"
          let-selectedView="selectedView"
        >

          <div kendoSchedulerToolbarNavigation></div>

          <div>KW {{weekNumber}}</div>
          <div *ngIf="selectedView.name == 'timelineMonth'"> - {{weekNumberEnd}}</div>

          <span class="k-spacer"></span>

          <div
            kendoSchedulerToolbarViewSelector
            class="k-scheduler-views-wrapper"
            [displayMode]="toolbarWidth < 960 ? 'compact' : 'default'"
          ></div>

        </ng-template>
      
        <kendo-scheduler-day-view
          slotDuration="60"
          slotDivisions="1"
        ></kendo-scheduler-day-view>

        <kendo-scheduler-week-view
        slotDuration="60"
        slotDivisions="1"
        ></kendo-scheduler-week-view>

        <!-- Same date header as the main planner (scheduler-shared) -->
        <ng-template kendoSchedulerDateHeaderTemplate let-date="date">
          <strong>{{ date | date: "EEEEEE dd.MM." }}</strong>
          @if (holidayName(date); as name) {
            <span class="holiday-name" [title]="name">{{ name }}</span>
          }
        </ng-template>

        <kendo-scheduler-messages
          [calendarToday]="t('scheduler-shared.calendarToday')"
          [today]="t('scheduler-shared.today')"
          [showWorkDay]="t('scheduler-shared.showWorkDay')"
          [showFullDay]="t('scheduler-shared.showFullDay')"
          [nextTitle]="t('scheduler-shared.nextTitle')"
          [previousTitle]="t('scheduler-shared.previousTitle')"
          [dayViewTitle]="t('scheduler-shared.dayViewTitle')"
          [weekViewTitle]="t('scheduler-shared.weekViewTitle')"
        >
        </kendo-scheduler-messages>

        <!-- All Day Events -->
        <ng-template 
          kendoSchedulerAllDayEventTemplate 
          let-event="event" 
          let-resources="resources"

        >
          <div class="schedulerItem">
            <div class="content">
              <div 
              class="eventTitle">
                  <ng-container *ngIf="event.dataItem.assignment?.id">
                    <p>
                      <a [routerLink]="['/assignment', event.dataItem.assignment.id]">
                        {{ event.dataItem.assignment?.title }} {{" | "}} {{ event.dataItem.assignment?.internalNumber }} 
                        <kendo-icon name="hyperlink-open" themeColor="secondary"></kendo-icon>
                      </a>
                    </p>
                  </ng-container>
                  <p>
                    <strong>
                      {{ event.title }}
                    </strong>
                  </p>
                  <p>{{event.dataItem.description}}</p>
                  <ng-container *ngFor="let ressource of event.dataItem.ressources; last as isLast">
                    {{ressource.name}}{{!isLast ? ", " : null}}
                  </ng-container>
              </div>
            </div>
          </div>
        </ng-template>

        <!-- regular Events -->
        <ng-template
            kendoSchedulerEventTemplate
            let-event="event"
            let-resources="resources"
          >
            <div class="schedulerItem">
              <div class="content">
                <div 
                class="eventTitle">
                    <ng-container *ngIf="event.dataItem.assignment?.id">
                      <p>
                        <a [routerLink]="['/assignment', event.dataItem.assignment.id]">
                          {{ event.dataItem.assignment?.title }} {{" | "}} {{ event.dataItem.assignment?.internalNumber }} 
                          <kendo-icon name="hyperlink-open" themeColor="secondary"></kendo-icon>
                        </a>
                      </p>
                    </ng-container>
                    <strong>
                      {{ event.title }} 
                    </strong>
                    <p>{{event.dataItem.description}}</p>
                    <ng-container *ngFor="let ressource of event.dataItem.ressources">
                      <p>{{ressource.name}}</p>
                    </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
      </kendo-scheduler>
    </div>
    }

    @case ('nextHolidays') {
    @if (nextHolidays.length) {
      <div class="box">
        <label class="bold pbs">{{ t('home.widgets.nextHolidays') }}</label>
        @for (holiday of nextHolidays; track holiday.start) {
          <div>{{ holiday.start | date: 'EE dd.MM.yyyy' }} {{ holiday.name }}</div>
        }
      </div>
    }
    }

    @case ('myBalances') {
      <div class="box">
        <label class="bold pbs">{{ t('home.widgets.myBalances') }}</label>
        <div>
          {{ t('time-entries.flexTimeBalance') }}:
          {{ (currentEmployee$ | async)?.flexTimeBalanceObj?.hours }} h
          {{ (currentEmployee$ | async)?.flexTimeBalanceObj?.minutes | number: '2.0' }} min
        </div>
        <div *ngIf="(tenantSettings$ | async)?.hasOvertime">
          {{ t('time-entries.overtimeBalance') }}:
          {{ (currentEmployee$ | async)?.overtimeBalanceObj?.hours }} h
          {{ (currentEmployee$ | async)?.overtimeBalanceObj?.minutes | number: '2.0' }} min
        </div>
        <div>
          {{ t('time-entries.vacationBalance') }}:
          {{ t('time-entries.vacationBalanceOfTotal', { balance: (currentEmployee$ | async)?.vacationBalance, total: (currentEmployee$ | async)?.vacationEntitlement }) }}
        </div>
      </div>
    }

    @case ('myNextAbsences') {
      <div class="box">
        <label class="bold pbs">{{ t('home.widgets.myNextAbsences') }}</label>
        @for (absence of nextAbsences; track absence.id) {
          <div>
            {{ absence.dateFrom | date: 'dd.MM.' }} – {{ absence.dateTo | date: 'dd.MM.yyyy' }}
            {{ absenceTypeName(absence.absenceType) }} ({{ absenceStateName(absence.absenceState) }})
          </div>
        } @empty {
          <div>{{ t('home.noAbsencesPlanned') }}</div>
        }
      </div>
    }

    @case ('absentToday') {
      <div class="box">
        <label class="bold pbs">{{ t('home.widgets.absentToday') }}</label>
        @for (absence of absentToday; track absence.id) {
          <div>
            {{ absence.employee?.firstName }} {{ absence.employee?.lastName }}:
            {{ absence.isRedacted ? t('absenceGroups.absent') : absenceTypeName(absence.absenceType) }}
          </div>
        } @empty {
          <div>{{ t('home.nobodyAbsent') }}</div>
        }
      </div>
    }
    }
    }
    }
    </div>

    <kendo-dialog
      *ngIf="widgetDialogOpened"
      [title]="t('home.widgetSettings')"
      (close)="widgetDialogOpened = false"
      [width]="400"
    >
      @for (widget of draftWidgets; track widget.key; let i = $index) {
        <div
          class="widget-picker-item"
          [class.drag-over]="dragOverIndex === i"
          [attr.data-widget-idx]="i"
        >
          <span
            class="drag-handle"
            (pointerdown)="onPointerDown(i, $event)"
            (pointermove)="onPointerMove($event)"
            (pointerup)="onPointerUp()"
            (pointercancel)="onPointerUp()"
          >
            <kendo-svg-icon [icon]="dragHandleIcon"></kendo-svg-icon>
          </span>
          <label style="display: flex; align-items: center; cursor: pointer; flex: 1;">
            <input
              type="checkbox"
              kendoCheckBox
              [checked]="widget.visible"
              (change)="toggleWidget(i, $any($event.target).checked)"
              style="margin-right: 0.5rem;"
            />
            {{ t('home.widgets.' + widget.key) }}
          </label>
        </div>
      }
      <kendo-dialog-actions>
        <button kendoButton type="button" (click)="widgetDialogOpened = false">{{ t('home.cancel') }}</button>
        <button kendoButton type="button" themeColor="primary" (click)="saveWidgets()">{{ t('home.save') }}</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </ng-container>
</ng-container>